import { useTranslation } from 'react-i18next';

import type { ScheduleRunCounts } from '@nucleus-commerce/api-client/admin';

const ORDER: Array<keyof ScheduleRunCounts> = [
  'published',
  'unpublished',
  'kept',
  'skipped',
  'reasserted',
  'released',
];

/** "3 published · 3 unpublished · 1 skipped", zeros left out. */
export function RunCounts({ counts }: { counts: ScheduleRunCounts }) {
  const { t } = useTranslation('schedules');
  const parts = ORDER.filter((key) => counts[key] > 0).map((key) =>
    t(`counts.${key}`, { count: counts[key] }),
  );
  return (
    <span className="text-muted-foreground tabular-nums">
      {parts.length > 0 ? parts.join(' · ') : t('counts.none')}
    </span>
  );
}
